export default __webpack_public_path__ + "static/media/2-5.11a3a739.webp";